"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertLngLatToArray = convertLngLatToArray;
function convertLngLatToArray({ latitude, longitude }) {
    return [longitude, latitude];
}
//# sourceMappingURL=convertLngLatToArray.js.map